import { Component, TrackByFunction } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, OperatorFunction, filter, map, switchMap } from 'rxjs';
import { LanguageService } from '../../../core/services/language.service';
import { SharedModule } from '../../../shared/shared.module';
import { TicketInformationComponent } from './ticket-information/ticket-information.component';
import { TicketTransactionTableComponent } from './ticket-transaction-table/ticket-transaction-table.component';
import { TicketDescriptionPipe } from './ticket-description.pipe';
import { UtilsService } from '../../../core/services/utils.service';
import { TicketData } from '../../../core/modules/tickets/ticket.types';
import { TicketApiService } from '../../../core/modules/tickets/ticket-api.service';

@Component({
  selector: 'tax-ticket-page',
  templateUrl: './ticket-page.component.html',
  styleUrls: ['./ticket-page.component.sass'],
  standalone: true,
  imports: [
    SharedModule,
    TicketInformationComponent,
    TicketTransactionTableComponent,
    TicketDescriptionPipe,
  ],
})
export class TicketPageComponent {
  readonly model$: Observable<TicketData> = this.getTicketModel();
  readonly trackByDescriptionIndex: TrackByFunction<string> = this.utilsService.trackByIndex;

  constructor(
    private activatedRoute: ActivatedRoute,
    private languageService: LanguageService,
    private ticketApiService: TicketApiService,
    private utilsService: UtilsService,
  ) {}

  private getTicketModel(): Observable<TicketData> {
    return this.languageService.languageChanges
      .pipe(
        switchMap(() => this.activatedRoute.paramMap),
        map(params => params.get('tid')),
        filter(ticketId => Boolean(ticketId)) as OperatorFunction<string | null, string>,
        switchMap(ticketId => this.ticketApiService.fetchTicket(ticketId)),
      );
  }
}
